import React from 'react'
import { compact } from 'lodash'

import PlainText from '../UI/PlainText'
import { LogoHeader, ProjectSummary, QuoteFooter } from './PrintableQuoteHeaders'

import './styles/quotes.css'

/*
MAIN COMPONENT -----------------------------------------------------------------

Props:
- quote: a quote object
- project: a project attribute INCLUDING:
  agency, client, user and agencyProducer
- print: Boolean: adapt quote to printing (default: false)
*/
const ClientFacingQuote = props => {
  const { quote, project, print } = props
  const agency = project.included('agency')
  const client = project.included('client')
  const user = project.included('user')
  const agencyProducer = project.included('agencyProducer')
  const projectTypeAddress = project.attributes.projectTypeAddress
//  const docketNumber = project.id;
  const docketNumber = project.attributes.formattedDocketNo;
  const summary = quote.attributes.formattedSummary
  const categories = summary.categories

  // Sorting categories properly for display
  let orderedCategoryKeys = []
  for (let categoryName in categories) {
    let index = Number(categories[categoryName].order)
    // Avoid overwriting items - we may have services with the same order.
    // In this case, keep adding 1 until we're not overwriting anything.
    // NOTE: Possibly an ugly hack that may bite me one day?
    while (orderedCategoryKeys[index]) {
      index += 1
    }
    orderedCategoryKeys[index] = categoryName
  }
  // Close gaps in array to make sure nothing blows up
  orderedCategoryKeys = compact(orderedCategoryKeys)

  // Red star noting there are values hidden from client
  const RedStar = () => <span style={{color: 'red'}}>* </span>

  const cssClassList = ['printable-quote']
  if (!print) cssClassList.push('client-facing-quote-screen')
  const cssClasses = cssClassList.join(' ')

  return (
    <section className={cssClasses}>
      <LogoHeader
        title="QUOTATION"
        docketNumber={docketNumber}
      />

      <ProjectSummary
        project={project}
        quote={quote}
        agency={agency}
        client={client}
        agencyProducer={agencyProducer}
        user={user}
      />

      <table className="quote-table">
        <thead>
          <tr>
            <th className="text-header">CATEGORY</th>
            <th className="service-header">SERVICE</th>
            <th className="number-header">NUMBER</th>
            <th className="number-header">RATE</th>
            <th className="number-header">PRICE</th>
          </tr>
        </thead>

        {orderedCategoryKeys.map(category => (
          <tbody key={`tbody-${category}`}>
            {categories[category].lineItems
              .sort((a, b) => a.order - b.order)
              .map((lineItem, index) => (
                <tr key={`tr-${category}-item-${index}`}>
                  <td className="category-column">
                    {index === 0 ? category : ''}
                  </td>
                  <td className="service-column">
                    <PlainText
                      className="service-description"
                      text={lineItem.description}
                    />
                  </td>
                  <td className="number-column">
                    {!print && lineItem.hideClientRates && <RedStar />}
                    {lineItem.number}
                  </td>
                  <td className="number-column">
                    {!print && lineItem.hideClientRates && <RedStar />}
                    {lineItem.formattedRateIncludingAdjustment}
                  </td>
                  <td className="number-column">{lineItem.formattedTotal}</td>
                </tr>
              ))}

            <tr key={`tr-${category}-total`}>
              <td colSpan={3} />
              <td className="category-total-title">{category}</td>
              <td className="category-total-price">
                {categories[category].formattedSubTotal}
              </td>
            </tr>

            <tr key={`tr-${category}-total-sep`} className="tr-separator">
              <td colSpan={5} />
            </tr>
          </tbody>
        ))}

        <tbody>
          {quote.attributes.notes && (
            <tr>
              <td colSpan={5} className="shaded">
                Notes:
                <PlainText text={quote.attributes.notes} />
              </td>
            </tr>
          )}
          <tr className="tr-separator">
            <td colSpan={5} />
          </tr>

          <tr>
            { (quote.attributes.totalDiscounts !== 0.00 && (
              <React.Fragment>
                 <td className="category-total-title">Total Discounts Applied:</td>
                  <td className="special-total-discount-amount"><div className="special-total-discount-amount-inner">{quote.attributes.formattedTotalDiscounts}</div></td>
                <td colSpan={1}/>
              </React.Fragment>
            )) || (
              <td colSpan={3} />
            )}
            <td className="category-total-title">Total (before taxes)</td>
            <td className="category-total-price">
              {quote.attributes.formattedGrossTotal}
            </td>
          </tr>

          <tr>
            <td colSpan={3} />
            <td className="shaded">Taxes ({quote.attributes.taxCode})</td>
            <td className="number-column">{quote.attributes.formattedTaxes}</td>
          </tr>
          <tr>
            <td colSpan={3} />
            <td className="shaded">Grand Total</td>
            <td className="number-column">
              {quote.attributes.formattedGrandTotal}
            </td>
          </tr>
        </tbody>
      </table>
      <QuoteFooter projectTypeAddress={projectTypeAddress} />
    </section>
  )
}

export default ClientFacingQuote



// WEBPACK FOOTER //
// ./src/components/Quotes/ClientFacingQuote.jsx